import { Link } from 'react-router-dom'
import { useI18n } from '../i18n/I18nProvider'
import { useAuthStore } from '../store/authStore'

function Footer() {
  const { t } = useI18n()
  const user = useAuthStore((state) => state.user)
  
  return (
    <footer className="bg-green-800 text-white py-8 mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-bold text-lg mb-4">{t('footer.brand.title')}</h3>
            <p className="text-green-200 text-sm">
              {t('footer.brand.description')}
            </p>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4">{t('footer.usefulLinks.title')}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/help" className="text-green-200 hover:text-white transition">
                  {t('footer.usefulLinks.help')}
                </Link>
              </li>
              <li>
                <Link to="/community" className="text-green-200 hover:text-white transition">
                  {t('footer.usefulLinks.community')}
                </Link>
              </li>
              {user && (
                <li>
                  <Link to="/shop" className="text-green-200 hover:text-white transition">
                    {t('footer.usefulLinks.shop')}
                  </Link>
                </li>
              )}
            </ul>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4">{t('footer.legal.title')}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/terms" className="text-green-200 hover:text-white transition">
                  {t('footer.legal.terms')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-green-200 hover:text-white transition">
                  {t('footer.legal.privacy')}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-green-700 text-center text-sm text-green-200">
          <p>&copy; {new Date().getFullYear()} {t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
